/* eslint-disable @typescript-eslint/naming-convention */
import {
  DocumentTypeFormData,
  DocumentTypePayload,
  DocumentTypesData,
} from '@data-access/configurations';
import { DELETE_DIALOG_DATA } from '@shared/dialogs/types';

export function mapDocumentTypeDataToDocumentForm(
  data: DocumentTypesData,
): DocumentTypeFormData | null {
  if (!data) {
    return null;
  }

  return {
    additionalIrisDocumentIds: data.data.legacy_ids ?? '',
    id: data.id,
    isActive: data.is_active ?? false,
    name: data.name,
    primaryIrisDocumentId: `${data.legacy_id ?? ''}`,
  };
}

export function mapDocumentFormDataToDocumentType(
  data: DocumentTypeFormData,
): DocumentTypePayload {
  return {
    allowed_workspace_types: [],
    description: '',
    id: data.id.toString(),
    is_active: data.isActive,
    legacy_id: +data.primaryIrisDocumentId,
    legacy_ids: data.additionalIrisDocumentIds?.toString() ?? '',
    name: data.name,
  };
}

export function constructDeleteDialogData(
  canDelete: boolean,
  canDeleteMessage: string,
): DELETE_DIALOG_DATA {
  return {
    buttons: {
      cancelButtonText: canDelete ? 'Cancel' : '',
      cancelColor: 'tertiary',
      deleteButtonText: canDelete ? 'Delete' : 'Done',
      primaryColor: canDelete ? 'primary-warn' : 'primary',
    },
    description: canDelete
      ? 'Are you sure you want to delete the document type?'
      : '',
    errorText: canDelete ? 'Reason for deletion field is required' : '',
    formControlName: 'deleteDocumentType',
    label: canDelete ? 'Reason for deletion' : '',
    message: canDeleteMessage ?? '',
    title: canDelete ? 'Delete Document Type' : '',
    type: canDelete ? 'DELETE' : 'MESSAGE',
  };
}
